import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DiscountsAndMultipliersService, SalesDocumentType, SalesDocumentTypeDict, Product } from '@icc/b2b/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { TranslateService } from '@ngx-translate/core';
import { SalesDocumentService } from '../sales-document.service';

@Component({
    selector: 'icc-cannot-add-product-dialog',
    templateUrl: './cannot-add-product-dialog.component.html',
    styleUrls: ['./cannot-add-product-dialog.component.scss'],
})
export class CannotAddProductDialogComponent {
    constructor(
        private salesDocumentService: SalesDocumentService,
        private translateService: TranslateService,
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            variant: boolean;
        },
        private router: Router
    ) {}

    get documentNumber() {
        const openedDocument = this.salesDocumentService.getOpenedDocument();
        if (openedDocument) {
            return this.translateService.instant(
                SalesDocumentTypeDict[openedDocument.salesDocumentTypeId]
            ) + ' ' + openedDocument.documentNumber.join('');
        }
        return '';
    }

    close() {
        this.dialogRef.close();
    }

    createQuotation() {
        this.dialogRef.close(true);
    }
}
